import * as React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate, Link } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
// @ts-ignore
import EmailLinkHandler from './components/auth/EmailLinkHandler';
import { LoginPage } from './components/auth/LoginPage';
import { MultiStepSignUpForm } from './components/auth/MultiStepSignUpForm';
import { LandingPage } from './landing';
import { Contact } from './landing/components/Contact';
import { LegalPage } from './pages/LegalPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { Language } from './i18n';
import { LangContext } from './landing';
import { useMediaQuery, useTheme, Box, Typography, Button } from '@mui/material';
import tacticaLogo from './assets/images/tacticaLogov3.png';
import NotificationHandler from './components/NotificationHandler';

function App() {
  // @ts-ignore
  const [lang, setLang] = React.useState<Language>('fr');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const location = useLocation();
  const navigate = useNavigate();
  const protectedPaths = ['/tutorial'];
  const isProtectedRoute = protectedPaths.some(p => location.pathname.startsWith(p));
  
  // Vérifier si le lien provient d'un email (contient le paramètre _se)
  const isEmailLink = location.search && location.search.includes('_se=');

  // Pas de redirection spécifique pour mobile - la page d'accueil est responsive

  // Import des composants avec React.lazy
  // @ts-ignore
  const TutorialPage = React.lazy(() => import('./pages/TutorialPage'));
  // @ts-ignore
  const TestimonialsPage = React.lazy(() => import('./pages/TestimonialsPage').then(m => ({ default: m.TestimonialsPage })));
  // @ts-ignore
  const FAQPage = React.lazy(() => import('./pages/FAQPage').then(m => ({ default: m.FAQPage })));
  
  return (
    <AuthProvider>
      <LangContext.Provider value={{ lang, setLang }}>
        <NotificationHandler />
        
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/connexion" element={<LoginPage />} />
          <Route path="/login" element={<Navigate to="/connexion" />} />
          <Route path="/signup" element={<MultiStepSignUpForm onError={console.error} />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/temoignages" element={
            // @ts-ignore
            <React.Suspense fallback={<div>Chargement...</div>}>
              <TestimonialsPage />
            </React.Suspense>
          } />
          <Route path="/faq" element={
            // @ts-ignore
            <React.Suspense fallback={<div>Chargement...</div>}>
              <FAQPage />
            </React.Suspense>
          } />
          <Route 
            path="/tutorial" 
            element={
              <ProtectedRoute>
                {/* @ts-ignore */}
                <React.Suspense fallback={<div>Chargement...</div>}>
                  <TutorialPage />
                </React.Suspense>
              </ProtectedRoute>
            } 
          />
          
          {/* Route spéciale pour intercepter les liens directs provenant des emails */}
          <Route 
            path="/app" 
            element={
              <ProtectedRoute>
                {/* @ts-ignore */}
                <React.Suspense fallback={<div>Chargement...</div>}>
                  {/* Si le lien vient d'un email (avec paramètre _se), utiliser EmailLinkHandler */}
                  {isEmailLink ? 
                    <EmailLinkHandler /> : 
                    <Navigate to="/tutorial" replace />
                  }
                </React.Suspense>
              </ProtectedRoute>
            } 
          />
          {/* Toutes les autres routes sont redirigées vers la page d'accueil */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </LangContext.Provider>
    </AuthProvider>
  );
}

export default App;
